import {
  DisplayName1fbm5f1dqkty3 as DisplayName,
  DoesNotNeedLabellvuub2wyj63e as DoesNotNeedLabel,
  TextIndex284xshohgiyzv as TextIndex,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import { ObjectSerializer2kjkucmygguwd as ObjectSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/ObjectSerializer.mjs';
import {
  ConditionAndSerializer19slt89ki7hw0 as ConditionAndSerializer,
  ConditionOrSerializer3tsbvckybs1gl as ConditionOrSerializer,
  ConditionNotSerializer2hwypspkjd4kk as ConditionNotSerializer,
  ConditionEqualSerializer1v5lg4nbzxvia as ConditionEqualSerializer,
  ConditionNotEqualSerializer2051eg4c8s5z1 as ConditionNotEqualSerializer,
  ConditionInsideSerializern68csv6xb4yt as ConditionInsideSerializer,
  ConditionNotInsideSerializerd6z6x5yvnjvh as ConditionNotInsideSerializer,
  ConditionGreaterThanSerializer2wzpqx0pwkin3 as ConditionGreaterThanSerializer,
  ConditionLessThanSerializer3u0xx1qztyncg as ConditionLessThanSerializer,
  ConditionGreaterThanOrEqualSerializer1sx8qme6p7zts as ConditionGreaterThanOrEqualSerializer,
  ConditionLessThanOrEqualSerializer2d97c0blodzea as ConditionLessThanOrEqualSerializer,
  ConditionIntBitsClearSerializer_getInstance3vhdaz6mubsl2 as ConditionIntBitsClearSerializer_getInstance,
  ConditionIntBitsSetSerializer_getInstance11zuknc24w7o9 as ConditionIntBitsSetSerializer_getInstance,
  ConditionIntBitsAnyClearSerializer_getInstance2zhinx3o90y8u as ConditionIntBitsAnyClearSerializer_getInstance,
  ConditionIntBitsAnySetSerializer_getInstance4vv5u7v6muh9 as ConditionIntBitsAnySetSerializer_getInstance,
  ConditionListAllElementsSerializer3sgf83jw85zog as ConditionListAllElementsSerializer,
  ConditionListAnyElementsSerializer22oqge0hpw89f as ConditionListAnyElementsSerializer,
  ConditionListSizesEqualsSerializerylq6zdmegxn2 as ConditionListSizesEqualsSerializer,
  ConditionSetAllElementsSerializer4uu2vw2zw7qo as ConditionSetAllElementsSerializer,
  ConditionSetAnyElementsSerializer129a7lg9rckmm as ConditionSetAnyElementsSerializer,
  ConditionSetSizesEqualsSerializerzfwxsye2lusb as ConditionSetSizesEqualsSerializer,
  ConditionExistsSerializer31noqg0z2vwgv as ConditionExistsSerializer,
  ConditionSerializer2v4zqxahhdocs as ConditionSerializer,
  ConditionIfNotNullSerializer1qp6j6wpu8isv as ConditionIfNotNullSerializer,
} from './ConditionSerialization.mjs';
import {
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
  DoubleSerializer_getInstance1tuvibnyg07o1 as DoubleSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  GeoCoordinateGeoJsonSerializer_getInstancew33zho1zb4lc as GeoCoordinateGeoJsonSerializer_getInstance,
  GeoCoordinate2xsokvzumk7qu as GeoCoordinate,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/GeoCoordinate.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  toList383f556t1dixk as toList,
  joinToStringxqcavsxcmh4q as joinToString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  isInterface3d6p8outrmvmk as isInterface,
  isComparableviyv6ctzm76u as isComparable,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString_0,
  toSet2orjxp16sotqu as toSet,
  firstOrNull1982767dljvdy as firstOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { toString30pk9tzaqopn as toString_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import {
  contains3ue2qo8xhmpf1 as contains,
  split2bvyvnrlcifjv as split,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { IsRawStringrx35rsigz3yf as IsRawString } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/StringAlts.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  emptyList1g2z5xcrvp2zy as emptyList,
  listOf1jh22dvmctj1r as listOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { serializer3pi9q3u39g4ku as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Companion_instance1gtxuhk57v96d as Companion_instance } from './TextQuery.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Default_getInstancevb13yk0g3h3e as Default_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/Json.mjs';
import {
  JsonObjectee06ihoeeiqj as JsonObject,
  JsonPrimitive3ttzjh2ft5dnx as JsonPrimitive,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-json/kotlinx/serialization/json/JsonElement.mjs';
import { CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  RegexOption_IGNORE_CASE_getInstance2fmuzo7a7o03f as RegexOption_IGNORE_CASE_getInstance,
  Regexxgw0gjiagf4z as Regex,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString1h6jjoch8cjt8 as toString_1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import {
  _SealedTypeDiscriminator___init__impl__jf77jnb2draso4x6g as _SealedTypeDiscriminator___init__impl__jf77jn,
  matches17hm1adjr5zld as matches,
  _SealedTypeDiscriminator___get_serialName__impl__x46m55cpdzns363t1u as _SealedTypeDiscriminator___get_serialName__impl__x46m55,
  SealedTypeDiscriminator__hashCode_impl_3l9vn82rzp7wjugbfem as SealedTypeDiscriminator__hashCode_impl_3l9vn8,
} from './SealedTypeDiscriminator.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../../../../kotlin-kotlin-stdlib/kotlin/Standard.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function Condition$Never$_anonymous__ewqlu4() {
  var tmp = Never_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [new (DisplayName())('None')];
  return ObjectSerializer().new_kotlinx_serialization_internal_ObjectSerializer_ezfnxd_k$('com.lightningkite.services.database.Condition.Never', tmp, tmp$ret$0);
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function Condition$Always$_anonymous__1v2vb3() {
  var tmp = Always_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [new (DisplayName())('All')];
  return ObjectSerializer().new_kotlinx_serialization_internal_ObjectSerializer_ezfnxd_k$('com.lightningkite.services.database.Condition.Always', tmp, tmp$ret$0);
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ConditionAndSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ConditionOrSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_1;
function Companion_getInstance_0() {
  return Companion_instance_1;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ConditionNotSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_2;
function Companion_getInstance_1() {
  return Companion_instance_2;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ConditionEqualSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_3;
function Companion_getInstance_2() {
  return Companion_instance_3;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ConditionNotEqualSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_4;
function Companion_getInstance_3() {
  return Companion_instance_4;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ConditionInsideSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_5;
function Companion_getInstance_4() {
  return Companion_instance_5;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ConditionNotInsideSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_6;
function Companion_getInstance_5() {
  return Companion_instance_6;
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ConditionGreaterThanSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_7;
function Companion_getInstance_6() {
  return Companion_instance_7;
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ConditionLessThanSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_8;
function Companion_getInstance_7() {
  return Companion_instance_8;
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ConditionGreaterThanOrEqualSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_9;
function Companion_getInstance_8() {
  return Companion_instance_9;
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ConditionLessThanOrEqualSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_10;
function Companion_getInstance_9() {
  return Companion_instance_10;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_11;
function Companion_getInstance_10() {
  return Companion_instance_11;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Condition.StringContains', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (DoesNotNeedLabel())());
        tmp0_serialDesc.addElement_5pzumi_k$('ignoreCase', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_t5cove_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.value_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.ignoreCase_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 1, value.ignoreCase_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_t5cove_k$(encoder, value instanceof StringContains() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return StringContains().new_com_lightningkite_services_database_Condition_StringContains_yaxa36_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      constructor() {
        Companion_instance_12 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Condition.RawStringContains', null, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        tmp0_serialDesc.addElement_5pzumi_k$('ignoreCase', true);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_qelnde_k$(typeSerial0) {
        return $serializer_0().new_com_lightningkite_services_database_Condition_RawStringContains_$serializer_uwde3f_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_12;
function Companion_getInstance_11() {
  if (Companion_instance_12 === VOID) {
    Companion_instance_29;
    new (Companion_11())();
  }
  return Companion_instance_12;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Condition_RawStringContains_$serializer_2wo5nf_k$();
      }
      static new_com_lightningkite_services_database_Condition_RawStringContains_$serializer_2wo5nf_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Condition.RawStringContains', $this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        tmp0_serialDesc.addElement_5pzumi_k$('ignoreCase', true);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_qur3mc_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.value_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.ignoreCase_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 1, value.ignoreCase_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_qur3mc_k$(encoder, value instanceof RawStringContains() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return RawStringContains().new_com_lightningkite_services_database_Condition_RawStringContains_opj7id_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_Condition_RawStringContains_$serializer_uwde3f_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_Condition_RawStringContains_$serializer_2wo5nf_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_13;
function Companion_getInstance_12() {
  return Companion_instance_13;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Condition.GeoDistance', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        tmp0_serialDesc.addElement_5pzumi_k$('greaterThanKilometers', true);
        tmp0_serialDesc.addElement_5pzumi_k$('lessThanKilometers', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_3c7dbg_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, GeoCoordinateGeoJsonSerializer_getInstance(), value.value_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !equals(value.greaterThanKilometers_1, 0.0)) {
          tmp1_output.encodeDoubleElement_a6rqhe_k$(tmp0_desc, 1, value.greaterThanKilometers_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !equals(value.lessThanKilometers_1, 100000.0)) {
          tmp1_output.encodeDoubleElement_a6rqhe_k$(tmp0_desc, 2, value.lessThanKilometers_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_3c7dbg_k$(encoder, value instanceof GeoDistance() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = 0.0;
        var tmp6_local2 = 0.0;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, GeoCoordinateGeoJsonSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeDoubleElement_isei84_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeDoubleElement_isei84_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, GeoCoordinateGeoJsonSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeDoubleElement_isei84_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeDoubleElement_isei84_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return GeoDistance().new_com_lightningkite_services_database_Condition_GeoDistance_x9tkze_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [GeoCoordinateGeoJsonSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_1())();
  return $serializer_instance_0;
}
var CompanionClass_13;
function Companion_13() {
  if (CompanionClass_13 === VOID) {
    class $ {
      constructor() {
        Companion_instance_14 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Condition.FullTextSearch', null, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        tmp0_serialDesc.addElement_5pzumi_k$('requireAllTermsPresent', true);
        tmp0_serialDesc.addElement_5pzumi_k$('levenshteinDistance', true);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_qelnde_k$(typeSerial0) {
        return $serializer_2().new_com_lightningkite_services_database_Condition_FullTextSearch_$serializer_jv9wfv_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_13 = $;
  }
  return CompanionClass_13;
}
var Companion_instance_14;
function Companion_getInstance_13() {
  if (Companion_instance_14 === VOID) {
    Companion_instance_29;
    new (Companion_13())();
  }
  return Companion_instance_14;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Condition_FullTextSearch_$serializer_9ic6md_k$();
      }
      static new_com_lightningkite_services_database_Condition_FullTextSearch_$serializer_9ic6md_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Condition.FullTextSearch', $this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (DoesNotNeedLabel())());
        tmp0_serialDesc.addElement_5pzumi_k$('requireAllTermsPresent', true);
        tmp0_serialDesc.addElement_5pzumi_k$('levenshteinDistance', true);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_z77sog_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.value_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.requireAllTermsPresent_1 === true)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 1, value.requireAllTermsPresent_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.levenshteinDistance_1 === 2)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 2, value.levenshteinDistance_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_z77sog_k$(encoder, value instanceof FullTextSearch() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_local2 = 0;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return FullTextSearch().new_com_lightningkite_services_database_Condition_FullTextSearch_wxfx9q_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), BooleanSerializer_getInstance(), IntSerializer_getInstance()];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_Condition_FullTextSearch_$serializer_jv9wfv_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_Condition_FullTextSearch_$serializer_9ic6md_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var CompanionClass_14;
function Companion_14() {
  if (CompanionClass_14 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_14 = $;
  }
  return CompanionClass_14;
}
var Companion_instance_15;
function Companion_getInstance_14() {
  return Companion_instance_15;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Condition.RegexMatches', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('pattern', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (DoesNotNeedLabel())());
        tmp0_serialDesc.addElement_5pzumi_k$('ignoreCase', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_gebdiq_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.pattern_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.ignoreCase_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 1, value.ignoreCase_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_gebdiq_k$(encoder, value instanceof RegexMatches() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return RegexMatches().new_com_lightningkite_services_database_Condition_RegexMatches_fdi56y_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_3())();
  return $serializer_instance_1;
}
var CompanionClass_15;
function Companion_15() {
  if (CompanionClass_15 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return ConditionIntBitsClearSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_15 = $;
  }
  return CompanionClass_15;
}
var Companion_instance_16;
function Companion_getInstance_15() {
  return Companion_instance_16;
}
var CompanionClass_16;
function Companion_16() {
  if (CompanionClass_16 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return ConditionIntBitsSetSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_16 = $;
  }
  return CompanionClass_16;
}
var Companion_instance_17;
function Companion_getInstance_16() {
  return Companion_instance_17;
}
var CompanionClass_17;
function Companion_17() {
  if (CompanionClass_17 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return ConditionIntBitsAnyClearSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_17 = $;
  }
  return CompanionClass_17;
}
var Companion_instance_18;
function Companion_getInstance_17() {
  return Companion_instance_18;
}
var CompanionClass_18;
function Companion_18() {
  if (CompanionClass_18 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return ConditionIntBitsAnySetSerializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_18 = $;
  }
  return CompanionClass_18;
}
var Companion_instance_19;
function Companion_getInstance_18() {
  return Companion_instance_19;
}
var CompanionClass_19;
function Companion_19() {
  if (CompanionClass_19 === VOID) {
    class $ {
      serializer_szze8_k$(typeSerial0) {
        return new (ConditionListAllElementsSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_szze8_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_19 = $;
  }
  return CompanionClass_19;
}
var Companion_instance_20;
function Companion_getInstance_19() {
  return Companion_instance_20;
}
var CompanionClass_20;
function Companion_20() {
  if (CompanionClass_20 === VOID) {
    class $ {
      serializer_szze8_k$(typeSerial0) {
        return new (ConditionListAnyElementsSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_szze8_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_20 = $;
  }
  return CompanionClass_20;
}
var Companion_instance_21;
function Companion_getInstance_20() {
  return Companion_instance_21;
}
var CompanionClass_21;
function Companion_21() {
  if (CompanionClass_21 === VOID) {
    class $ {
      serializer_szze8_k$(typeSerial0) {
        return new (ConditionListSizesEqualsSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_szze8_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_21 = $;
  }
  return CompanionClass_21;
}
var Companion_instance_22;
function Companion_getInstance_21() {
  return Companion_instance_22;
}
var CompanionClass_22;
function Companion_22() {
  if (CompanionClass_22 === VOID) {
    class $ {
      serializer_szze8_k$(typeSerial0) {
        return new (ConditionSetAllElementsSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_szze8_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_22 = $;
  }
  return CompanionClass_22;
}
var Companion_instance_23;
function Companion_getInstance_22() {
  return Companion_instance_23;
}
var CompanionClass_23;
function Companion_23() {
  if (CompanionClass_23 === VOID) {
    class $ {
      serializer_szze8_k$(typeSerial0) {
        return new (ConditionSetAnyElementsSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_szze8_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_23 = $;
  }
  return CompanionClass_23;
}
var Companion_instance_24;
function Companion_getInstance_23() {
  return Companion_instance_24;
}
var CompanionClass_24;
function Companion_24() {
  if (CompanionClass_24 === VOID) {
    class $ {
      serializer_szze8_k$(typeSerial0) {
        return new (ConditionSetSizesEqualsSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_szze8_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_24 = $;
  }
  return CompanionClass_24;
}
var Companion_instance_25;
function Companion_getInstance_24() {
  return Companion_instance_25;
}
var CompanionClass_25;
function Companion_25() {
  if (CompanionClass_25 === VOID) {
    class $ {
      serializer_r07i7m_k$(typeSerial0) {
        return new (ConditionExistsSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_r07i7m_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_25 = $;
  }
  return CompanionClass_25;
}
var Companion_instance_26;
function Companion_getInstance_25() {
  return Companion_instance_26;
}
var CompanionClass_26;
function Companion_26() {
  if (CompanionClass_26 === VOID) {
    class $ {
      constructor() {
        Companion_instance_27 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Condition.OnKey', null, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('key', false);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', false);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_r07i7m_k$(typeSerial0) {
        return $serializer_4().new_com_lightningkite_services_database_Condition_OnKey_$serializer_d7zya1_k$(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_r07i7m_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_26 = $;
  }
  return CompanionClass_26;
}
var Companion_instance_27;
function Companion_getInstance_26() {
  if (Companion_instance_27 === VOID) {
    Companion_instance_29;
    new (Companion_26())();
  }
  return Companion_instance_27;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Condition_OnKey_$serializer_qlj8wb_k$();
      }
      static new_com_lightningkite_services_database_Condition_OnKey_$serializer_qlj8wb_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.Condition.OnKey', $this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('key', false);
        tmp0_serialDesc.addElement_5pzumi_k$('condition', false);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_d6hlg6_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.key_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), value.condition_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_d6hlg6_k$(encoder, value instanceof OnKey() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, new (ConditionSerializer())(this.typeSerial0__1), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return OnKey().new_com_lightningkite_services_database_Condition_OnKey_hbw11w_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), new (ConditionSerializer())(this.typeSerial0__1)];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1];
      }
      static new_com_lightningkite_services_database_Condition_OnKey_$serializer_d7zya1_k$(typeSerial0) {
        var $this = this.new_com_lightningkite_services_database_Condition_OnKey_$serializer_qlj8wb_k$();
        $this.typeSerial0__1 = typeSerial0;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var CompanionClass_27;
function Companion_27() {
  if (CompanionClass_27 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ConditionIfNotNullSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_27 = $;
  }
  return CompanionClass_27;
}
var Companion_instance_28;
function Companion_getInstance_27() {
  return Companion_instance_28;
}
var NeverClass;
function Never() {
  if (NeverClass === VOID) {
    class $ extends Condition() {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Condition_Never_iyrala_k$();
      }
      static new_com_lightningkite_services_database_Condition_Never_iyrala_k$() {
        Never_instance = null;
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        Never_instance = $this;
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, Condition$Never$_anonymous__ewqlu4);
        return $this;
      }
      invoke_cywwop_k$(on) {
        return false;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_cywwop_k$(on);
      }
      toString() {
        return 'false';
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
      hashCode() {
        return 1916867540;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Never()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Never', VOID, VOID, [SerializerFactory()], VOID, VOID, {0: Never_getInstance});
    NeverClass = $;
  }
  return NeverClass;
}
var Never_instance;
function Never_getInstance() {
  if (Never_instance === VOID)
    Never().new_com_lightningkite_services_database_Condition_Never_iyrala_k$();
  return Never_instance;
}
var AlwaysClass;
function Always() {
  if (AlwaysClass === VOID) {
    class $ extends Condition() {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Condition_Always_pqbn7r_k$();
      }
      static new_com_lightningkite_services_database_Condition_Always_pqbn7r_k$() {
        Always_instance = null;
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        Always_instance = $this;
        var tmp = $this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, Condition$Always$_anonymous__1v2vb3);
        return $this;
      }
      invoke_cywwop_k$(on) {
        return true;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_cywwop_k$(on);
      }
      toString() {
        return 'true';
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
      hashCode() {
        return -1072336441;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Always()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'Always', VOID, VOID, [SerializerFactory()], VOID, VOID, {0: Always_getInstance});
    AlwaysClass = $;
  }
  return AlwaysClass;
}
var Always_instance;
function Always_getInstance() {
  if (Always_instance === VOID)
    Always().new_com_lightningkite_services_database_Condition_Always_pqbn7r_k$();
  return Always_instance;
}
var AndClass;
function And() {
  if (AndClass === VOID) {
    class $ extends Condition() {
      constructor(conditions) {
        return new.target.new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(conditions);
      }
      static new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(conditions) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.conditions_1 = conditions;
        return $this;
      }
      static new_com_lightningkite_services_database_Condition_And_ln02sz_k$(conditions) {
        return this.new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(toList(conditions));
      }
      invoke_wbynzd_k$(on) {
        var tmp0 = this.conditions_1;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (!element.invoke_wbynzd_k$(on)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      toString() {
        return joinToString_0(this.conditions_1, ' && ', '(', ')');
      }
      hashCode() {
        return hashCode(this.conditions_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof And()))
          return false;
        if (!equals(this.conditions_1, other.conditions_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'And', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance});
    AndClass = $;
  }
  return AndClass;
}
var OrClass;
function Or() {
  if (OrClass === VOID) {
    class $ extends Condition() {
      constructor(conditions) {
        return new.target.new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(conditions);
      }
      static new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(conditions) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.conditions_1 = conditions;
        return $this;
      }
      invoke_wbynzd_k$(on) {
        var tmp0 = this.conditions_1;
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(tmp0, Collection())) {
            tmp = tmp0.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (element.invoke_wbynzd_k$(on)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        return tmp$ret$0;
      }
      toString() {
        return joinToString_0(this.conditions_1, ' || ', '(', ')');
      }
      hashCode() {
        return hashCode(this.conditions_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Or()))
          return false;
        if (!equals(this.conditions_1, other.conditions_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Or', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_0});
    OrClass = $;
  }
  return OrClass;
}
var NotClass;
function Not() {
  if (NotClass === VOID) {
    class $ extends Condition() {
      constructor(condition) {
        return new.target.new_com_lightningkite_services_database_Condition_Not_bthq7d_k$(condition);
      }
      static new_com_lightningkite_services_database_Condition_Not_bthq7d_k$(condition) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.condition_1 = condition;
        return $this;
      }
      invoke_wbynzd_k$(on) {
        return !this.condition_1.invoke_wbynzd_k$(on);
      }
      toString() {
        return '!(' + toString(this.condition_1) + ')';
      }
      hashCode() {
        return this.condition_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Not()))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Not', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_1});
    NotClass = $;
  }
  return NotClass;
}
var EqualClass;
function Equal() {
  if (EqualClass === VOID) {
    class $ extends Condition() {
      constructor(value) {
        return new.target.new_com_lightningkite_services_database_Condition_Equal_nldxtl_k$(value);
      }
      static new_com_lightningkite_services_database_Condition_Equal_nldxtl_k$(value) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        return $this;
      }
      invoke_wbynzd_k$(on) {
        return equals(on, this.value_1);
      }
      toString() {
        return ' == ' + toString_0(this.value_1);
      }
      hashCode() {
        return this.value_1 == null ? 0 : hashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Equal()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Equal', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_2});
    EqualClass = $;
  }
  return EqualClass;
}
var NotEqualClass;
function NotEqual() {
  if (NotEqualClass === VOID) {
    class $ extends Condition() {
      constructor(value) {
        return new.target.new_com_lightningkite_services_database_Condition_NotEqual_vy8bqe_k$(value);
      }
      static new_com_lightningkite_services_database_Condition_NotEqual_vy8bqe_k$(value) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        return $this;
      }
      invoke_wbynzd_k$(on) {
        return !equals(on, this.value_1);
      }
      toString() {
        return ' != ' + toString_0(this.value_1);
      }
      hashCode() {
        return this.value_1 == null ? 0 : hashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NotEqual()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'NotEqual', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_3});
    NotEqualClass = $;
  }
  return NotEqualClass;
}
var InsideClass;
function Inside() {
  if (InsideClass === VOID) {
    class $ extends Condition() {
      constructor(values) {
        return new.target.new_com_lightningkite_services_database_Condition_Inside_7n2d7w_k$(values);
      }
      static new_com_lightningkite_services_database_Condition_Inside_7n2d7w_k$(values) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.values_1 = values;
        return $this;
      }
      static new_com_lightningkite_services_database_Condition_Inside_16ypu3_k$(values) {
        return this.new_com_lightningkite_services_database_Condition_Inside_7n2d7w_k$(toSet(values));
      }
      invoke_wbynzd_k$(on) {
        return this.values_1.contains_aljjnj_k$(on);
      }
      toString() {
        return ' in ' + toString(this.values_1);
      }
      hashCode() {
        return hashCode(this.values_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Inside()))
          return false;
        if (!equals(this.values_1, other.values_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Inside', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_4});
    InsideClass = $;
  }
  return InsideClass;
}
var NotInsideClass;
function NotInside() {
  if (NotInsideClass === VOID) {
    class $ extends Condition() {
      constructor(values) {
        return new.target.new_com_lightningkite_services_database_Condition_NotInside_f2mn7v_k$(values);
      }
      static new_com_lightningkite_services_database_Condition_NotInside_f2mn7v_k$(values) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.values_1 = values;
        return $this;
      }
      static new_com_lightningkite_services_database_Condition_NotInside_85h2wk_k$(values) {
        return this.new_com_lightningkite_services_database_Condition_NotInside_f2mn7v_k$(toSet(values));
      }
      invoke_wbynzd_k$(on) {
        return !this.values_1.contains_aljjnj_k$(on);
      }
      toString() {
        return ' !in ' + toString(this.values_1);
      }
      hashCode() {
        return hashCode(this.values_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NotInside()))
          return false;
        if (!equals(this.values_1, other.values_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'NotInside', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_5});
    NotInsideClass = $;
  }
  return NotInsideClass;
}
var GreaterThanClass;
function GreaterThan() {
  if (GreaterThanClass === VOID) {
    class $ extends Condition() {
      constructor(value) {
        return new.target.new_com_lightningkite_services_database_Condition_GreaterThan_u1sdk2_k$(value);
      }
      static new_com_lightningkite_services_database_Condition_GreaterThan_u1sdk2_k$(value) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        return $this;
      }
      invoke_pnt4bv_k$(on) {
        return compareTo(on, this.value_1) > 0;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_pnt4bv_k$((!(on == null) ? isComparable(on) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' > ' + toString(this.value_1);
      }
      hashCode() {
        return hashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GreaterThan()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GreaterThan', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_6});
    GreaterThanClass = $;
  }
  return GreaterThanClass;
}
var LessThanClass;
function LessThan() {
  if (LessThanClass === VOID) {
    class $ extends Condition() {
      constructor(value) {
        return new.target.new_com_lightningkite_services_database_Condition_LessThan_vay77v_k$(value);
      }
      static new_com_lightningkite_services_database_Condition_LessThan_vay77v_k$(value) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        return $this;
      }
      invoke_pnt4bv_k$(on) {
        return compareTo(on, this.value_1) < 0;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_pnt4bv_k$((!(on == null) ? isComparable(on) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' < ' + toString(this.value_1);
      }
      hashCode() {
        return hashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LessThan()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'LessThan', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_7});
    LessThanClass = $;
  }
  return LessThanClass;
}
var GreaterThanOrEqualClass;
function GreaterThanOrEqual() {
  if (GreaterThanOrEqualClass === VOID) {
    class $ extends Condition() {
      constructor(value) {
        return new.target.new_com_lightningkite_services_database_Condition_GreaterThanOrEqual_65340f_k$(value);
      }
      static new_com_lightningkite_services_database_Condition_GreaterThanOrEqual_65340f_k$(value) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        return $this;
      }
      invoke_pnt4bv_k$(on) {
        return compareTo(on, this.value_1) >= 0;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_pnt4bv_k$((!(on == null) ? isComparable(on) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' >= ' + toString(this.value_1);
      }
      hashCode() {
        return hashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GreaterThanOrEqual()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'GreaterThanOrEqual', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_8});
    GreaterThanOrEqualClass = $;
  }
  return GreaterThanOrEqualClass;
}
var LessThanOrEqualClass;
function LessThanOrEqual() {
  if (LessThanOrEqualClass === VOID) {
    class $ extends Condition() {
      constructor(value) {
        return new.target.new_com_lightningkite_services_database_Condition_LessThanOrEqual_z59w3m_k$(value);
      }
      static new_com_lightningkite_services_database_Condition_LessThanOrEqual_z59w3m_k$(value) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        return $this;
      }
      invoke_pnt4bv_k$(on) {
        return compareTo(on, this.value_1) <= 0;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_pnt4bv_k$((!(on == null) ? isComparable(on) : false) ? on : THROW_CCE());
      }
      toString() {
        return ' <= ' + toString(this.value_1);
      }
      hashCode() {
        return hashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LessThanOrEqual()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'LessThanOrEqual', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_9});
    LessThanOrEqualClass = $;
  }
  return LessThanOrEqualClass;
}
var StringContainsClass;
function StringContains() {
  if (StringContainsClass === VOID) {
    class $ extends Condition() {
      constructor(value, ignoreCase) {
        return new.target.new_com_lightningkite_services_database_Condition_StringContains_glssca_k$(value, ignoreCase);
      }
      static new_com_lightningkite_services_database_Condition_StringContains_glssca_k$(value, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        $this.ignoreCase_1 = ignoreCase;
        return $this;
      }
      invoke_lt562m_k$(on) {
        return contains(on, this.value_1, this.ignoreCase_1);
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_lt562m_k$((!(on == null) ? typeof on === 'string' : false) ? on : THROW_CCE());
      }
      toString() {
        return '.contains(' + this.value_1 + ', ' + this.ignoreCase_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.value_1);
        result = imul(result, 31) + getBooleanHashCode(this.ignoreCase_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof StringContains()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        if (!(this.ignoreCase_1 === other.ignoreCase_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_Condition_StringContains_yaxa36_k$(seen0, value, ignoreCase, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        if (0 === (seen0 & 2))
          $this.ignoreCase_1 = false;
        else
          $this.ignoreCase_1 = ignoreCase;
        return $this;
      }
    }
    initMetadataForClass($, 'StringContains', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    StringContainsClass = $;
  }
  return StringContainsClass;
}
var RawStringContainsClass;
function RawStringContains() {
  if (RawStringContainsClass === VOID) {
    class $ extends Condition() {
      constructor(value, ignoreCase) {
        return new.target.new_com_lightningkite_services_database_Condition_RawStringContains_dkubqt_k$(value, ignoreCase);
      }
      static new_com_lightningkite_services_database_Condition_RawStringContains_dkubqt_k$(value, ignoreCase) {
        Companion_getInstance_11();
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        $this.ignoreCase_1 = ignoreCase;
        return $this;
      }
      invoke_am4b9c_k$(on) {
        return contains(on.get_raw_18ix4x_k$(), this.value_1, this.ignoreCase_1);
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_am4b9c_k$((!(on == null) ? isInterface(on, IsRawString()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.contains(' + this.value_1 + ', ' + this.ignoreCase_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.value_1);
        result = imul(result, 31) + getBooleanHashCode(this.ignoreCase_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RawStringContains()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        if (!(this.ignoreCase_1 === other.ignoreCase_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_Condition_RawStringContains_opj7id_k$(seen0, value, ignoreCase, serializationConstructorMarker) {
        Companion_getInstance_11();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, Companion_getInstance_11().$cachedDescriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        if (0 === (seen0 & 2))
          $this.ignoreCase_1 = false;
        else
          $this.ignoreCase_1 = ignoreCase;
        return $this;
      }
    }
    initMetadataForClass($, 'RawStringContains', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_11});
    RawStringContainsClass = $;
  }
  return RawStringContainsClass;
}
var GeoDistanceClass;
function GeoDistance() {
  if (GeoDistanceClass === VOID) {
    class $ extends Condition() {
      constructor(value, greaterThanKilometers, lessThanKilometers) {
        return new.target.new_com_lightningkite_services_database_Condition_GeoDistance_g9cnd3_k$(value, greaterThanKilometers, lessThanKilometers);
      }
      static new_com_lightningkite_services_database_Condition_GeoDistance_g9cnd3_k$(value, greaterThanKilometers, lessThanKilometers) {
        greaterThanKilometers = greaterThanKilometers === VOID ? 0.0 : greaterThanKilometers;
        lessThanKilometers = lessThanKilometers === VOID ? 100000.0 : lessThanKilometers;
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        $this.greaterThanKilometers_1 = greaterThanKilometers;
        $this.lessThanKilometers_1 = lessThanKilometers;
        return $this;
      }
      invoke_mida55_k$(on) {
        var containsLower = this.greaterThanKilometers_1;
        var containsUpper = this.lessThanKilometers_1;
        var containsArg = on.distanceToKilometers_gyt5cm_k$(this.value_1);
        return containsLower <= containsArg ? containsArg <= containsUpper : false;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_mida55_k$(on instanceof GeoCoordinate() ? on : THROW_CCE());
      }
      toString() {
        return '.distanceToKilometers(value) in ' + this.greaterThanKilometers_1 + '..' + this.lessThanKilometers_1;
      }
      hashCode() {
        var result = this.value_1.hashCode();
        result = imul(result, 31) + getNumberHashCode(this.greaterThanKilometers_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.lessThanKilometers_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof GeoDistance()))
          return false;
        if (!this.value_1.equals(other.value_1))
          return false;
        if (!equals(this.greaterThanKilometers_1, other.greaterThanKilometers_1))
          return false;
        if (!equals(this.lessThanKilometers_1, other.lessThanKilometers_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_Condition_GeoDistance_x9tkze_k$(seen0, value, greaterThanKilometers, lessThanKilometers, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_0().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        if (0 === (seen0 & 2))
          $this.greaterThanKilometers_1 = 0.0;
        else
          $this.greaterThanKilometers_1 = greaterThanKilometers;
        if (0 === (seen0 & 4))
          $this.lessThanKilometers_1 = 100000.0;
        else
          $this.lessThanKilometers_1 = lessThanKilometers;
        return $this;
      }
    }
    initMetadataForClass($, 'GeoDistance', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    GeoDistanceClass = $;
  }
  return GeoDistanceClass;
}
var FullTextSearchClass;
function FullTextSearch() {
  if (FullTextSearchClass === VOID) {
    class $ extends Condition() {
      constructor(value, requireAllTermsPresent, levenshteinDistance) {
        return new.target.new_com_lightningkite_services_database_Condition_FullTextSearch_hz7vav_k$(value, requireAllTermsPresent, levenshteinDistance);
      }
      static new_com_lightningkite_services_database_Condition_FullTextSearch_hz7vav_k$(value, requireAllTermsPresent, levenshteinDistance) {
        Companion_getInstance_13();
        requireAllTermsPresent = requireAllTermsPresent === VOID ? true : requireAllTermsPresent;
        levenshteinDistance = levenshteinDistance === VOID ? 2 : levenshteinDistance;
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        $this.requireAllTermsPresent_1 = requireAllTermsPresent;
        $this.levenshteinDistance_1 = levenshteinDistance;
        return $this;
      }
      invoke_wbynzd_k$(on) {
        if (on == null)
          return false;
        var tmp;
        try {
          var tmp_0 = getKClassFromExpression(on);
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = serializer(tmp_0, tmp$ret$0, false);
        } catch ($p) {
          var tmp_1;
          if ($p instanceof Exception()) {
            var e = $p;
            tmp_1 = null;
          } else {
            throw $p;
          }
          tmp = tmp_1;
        }
        var ser = tmp;
        if (!(ser == null) && equals(ser.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), CLASS_getInstance())) {
          // Inline function 'kotlin.collections.filterIsInstance' call
          var tmp0 = ser.get_descriptor_wjt6a0_k$().get_annotations_20dirp_k$();
          // Inline function 'kotlin.collections.filterIsInstanceTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (element instanceof TextIndex()) {
              destination.add_utx5q5_k$(element);
            }
          }
          var tmp0_safe_receiver = firstOrNull(destination);
          var fieldNames = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.fields_1;
          var tmp_2 = Default_getInstance().encodeToJsonElement_w5lo4o_k$(ser, on);
          var element_0 = tmp_2 instanceof JsonObject() ? tmp_2 : null;
          var tmp_3;
          if (element_0 == null) {
            tmp_3 = null;
          } else {
            // Inline function 'kotlin.let' call
            var e_0 = element_0;
            var tmp_4;
            if (fieldNames == null) {
              tmp_4 = null;
            } else {
              tmp_4 = joinToString(fieldNames, ' ', VOID, VOID, VOID, VOID, (fieldPath) => {
                var pathParts = split(fieldPath, ['.']);
                var current = e_0;
                var _iterator__ex2g4s = pathParts.iterator_jk1svi_k$();
                $l$loop: while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
                  var part = _iterator__ex2g4s.next_20eer_k$();
                  var tmp0_safe_receiver = current instanceof JsonObject() ? current : null;
                  current = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_6bo4tg_k$(part);
                  if (current == null)
                    break $l$loop;
                }
                var p = current;
                var tmp;
                if (p instanceof JsonPrimitive()) {
                  tmp = p.get_content_h02jrk_k$();
                } else {
                  if (p == null) {
                    tmp = '';
                  } else {
                    tmp = toString(p);
                  }
                }
                return tmp;
              });
            }
            tmp_3 = tmp_4;
          }
          var tmp2_elvis_lhs = tmp_3;
          var fromString = tmp2_elvis_lhs == null ? toString(on) : tmp2_elvis_lhs;
          return Companion_instance.fromString_g5hge7_k$(this.value_1).fuzzyPresent_hkafn3_k$(fromString, this.levenshteinDistance_1);
        } else
          return Companion_instance.fromString_g5hge7_k$(this.value_1).fuzzyPresent_hkafn3_k$(toString(on), this.levenshteinDistance_1);
      }
      toString() {
        return '.fullTextSearch(' + this.value_1 + ', ' + this.requireAllTermsPresent_1 + ', ' + this.levenshteinDistance_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.value_1);
        result = imul(result, 31) + getBooleanHashCode(this.requireAllTermsPresent_1) | 0;
        result = imul(result, 31) + this.levenshteinDistance_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FullTextSearch()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        if (!(this.requireAllTermsPresent_1 === other.requireAllTermsPresent_1))
          return false;
        if (!(this.levenshteinDistance_1 === other.levenshteinDistance_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_Condition_FullTextSearch_wxfx9q_k$(seen0, value, requireAllTermsPresent, levenshteinDistance, serializationConstructorMarker) {
        Companion_getInstance_13();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, Companion_getInstance_13().$cachedDescriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.value_1 = value;
        if (0 === (seen0 & 2))
          $this.requireAllTermsPresent_1 = true;
        else
          $this.requireAllTermsPresent_1 = requireAllTermsPresent;
        if (0 === (seen0 & 4))
          $this.levenshteinDistance_1 = 2;
        else
          $this.levenshteinDistance_1 = levenshteinDistance;
        return $this;
      }
    }
    initMetadataForClass($, 'FullTextSearch', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_13});
    FullTextSearchClass = $;
  }
  return FullTextSearchClass;
}
var RegexMatchesClass;
function RegexMatches() {
  if (RegexMatchesClass === VOID) {
    class $ extends Condition() {
      constructor(pattern, ignoreCase) {
        return new.target.new_com_lightningkite_services_database_Condition_RegexMatches_oqe2oy_k$(pattern, ignoreCase);
      }
      static new_com_lightningkite_services_database_Condition_RegexMatches_oqe2oy_k$(pattern, ignoreCase) {
        ignoreCase = ignoreCase === VOID ? false : ignoreCase;
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.pattern_1 = pattern;
        $this.ignoreCase_1 = ignoreCase;
        var tmp = $this;
        var tmp_0;
        if ($this.ignoreCase_1) {
          tmp_0 = setOf(RegexOption_IGNORE_CASE_getInstance());
        } else {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        }
        tmp.regex_1 = Regex().new_kotlin_text_Regex_w1mv1w_k$($this.pattern_1, tmp_0);
        return $this;
      }
      invoke_lt562m_k$(on) {
        return this.regex_1.containsMatchIn_gpzk5u_k$(on);
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_lt562m_k$((!(on == null) ? typeof on === 'string' : false) ? on : THROW_CCE());
      }
      toString() {
        return '.contains(Regex(' + this.pattern_1 + '), ' + this.ignoreCase_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.pattern_1);
        result = imul(result, 31) + getBooleanHashCode(this.ignoreCase_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RegexMatches()))
          return false;
        if (!(this.pattern_1 === other.pattern_1))
          return false;
        if (!(this.ignoreCase_1 === other.ignoreCase_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_Condition_RegexMatches_fdi56y_k$(seen0, pattern, ignoreCase, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_1().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.pattern_1 = pattern;
        if (0 === (seen0 & 2))
          $this.ignoreCase_1 = false;
        else
          $this.ignoreCase_1 = ignoreCase;
        var tmp = $this;
        var tmp_0;
        if ($this.ignoreCase_1) {
          tmp_0 = setOf(RegexOption_IGNORE_CASE_getInstance());
        } else {
          // Inline function 'kotlin.collections.setOf' call
          tmp_0 = emptySet();
        }
        tmp.regex_1 = Regex().new_kotlin_text_Regex_w1mv1w_k$($this.pattern_1, tmp_0);
        return $this;
      }
    }
    initMetadataForClass($, 'RegexMatches', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    RegexMatchesClass = $;
  }
  return RegexMatchesClass;
}
var IntBitsClearClass;
function IntBitsClear() {
  if (IntBitsClearClass === VOID) {
    class $ extends Condition() {
      constructor(mask) {
        return new.target.new_com_lightningkite_services_database_Condition_IntBitsClear_b2evjq_k$(mask);
      }
      static new_com_lightningkite_services_database_Condition_IntBitsClear_b2evjq_k$(mask) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.mask_1 = mask;
        return $this;
      }
      invoke_dlyhwg_k$(on) {
        return (on & this.mask_1) === 0;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_dlyhwg_k$((!(on == null) ? typeof on === 'number' : false) ? on : THROW_CCE());
      }
      toString() {
        return '.bitsClear(' + toString_1(this.mask_1, 16) + ')';
      }
      hashCode() {
        return this.mask_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IntBitsClear()))
          return false;
        if (!(this.mask_1 === other.mask_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IntBitsClear', VOID, VOID, VOID, VOID, VOID, {0: ConditionIntBitsClearSerializer_getInstance});
    IntBitsClearClass = $;
  }
  return IntBitsClearClass;
}
var IntBitsSetClass;
function IntBitsSet() {
  if (IntBitsSetClass === VOID) {
    class $ extends Condition() {
      constructor(mask) {
        return new.target.new_com_lightningkite_services_database_Condition_IntBitsSet_o8ycvz_k$(mask);
      }
      static new_com_lightningkite_services_database_Condition_IntBitsSet_o8ycvz_k$(mask) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.mask_1 = mask;
        return $this;
      }
      invoke_dlyhwg_k$(on) {
        return (on & this.mask_1) === this.mask_1;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_dlyhwg_k$((!(on == null) ? typeof on === 'number' : false) ? on : THROW_CCE());
      }
      toString() {
        return '.bitsSet(' + toString_1(this.mask_1, 16) + ')';
      }
      hashCode() {
        return this.mask_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IntBitsSet()))
          return false;
        if (!(this.mask_1 === other.mask_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IntBitsSet', VOID, VOID, VOID, VOID, VOID, {0: ConditionIntBitsSetSerializer_getInstance});
    IntBitsSetClass = $;
  }
  return IntBitsSetClass;
}
var IntBitsAnyClearClass;
function IntBitsAnyClear() {
  if (IntBitsAnyClearClass === VOID) {
    class $ extends Condition() {
      constructor(mask) {
        return new.target.new_com_lightningkite_services_database_Condition_IntBitsAnyClear_r9bmj0_k$(mask);
      }
      static new_com_lightningkite_services_database_Condition_IntBitsAnyClear_r9bmj0_k$(mask) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.mask_1 = mask;
        return $this;
      }
      invoke_dlyhwg_k$(on) {
        return !((on & this.mask_1) === this.mask_1);
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_dlyhwg_k$((!(on == null) ? typeof on === 'number' : false) ? on : THROW_CCE());
      }
      toString() {
        return '.bitsAnyClear(' + toString_1(this.mask_1, 16) + ')';
      }
      hashCode() {
        return this.mask_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IntBitsAnyClear()))
          return false;
        if (!(this.mask_1 === other.mask_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IntBitsAnyClear', VOID, VOID, VOID, VOID, VOID, {0: ConditionIntBitsAnyClearSerializer_getInstance});
    IntBitsAnyClearClass = $;
  }
  return IntBitsAnyClearClass;
}
var IntBitsAnySetClass;
function IntBitsAnySet() {
  if (IntBitsAnySetClass === VOID) {
    class $ extends Condition() {
      constructor(mask) {
        return new.target.new_com_lightningkite_services_database_Condition_IntBitsAnySet_1myno7_k$(mask);
      }
      static new_com_lightningkite_services_database_Condition_IntBitsAnySet_1myno7_k$(mask) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.mask_1 = mask;
        return $this;
      }
      invoke_dlyhwg_k$(on) {
        return !((on & this.mask_1) === 0);
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_dlyhwg_k$((!(on == null) ? typeof on === 'number' : false) ? on : THROW_CCE());
      }
      toString() {
        return '.bitsAnySet(' + toString_1(this.mask_1, 16) + ')';
      }
      hashCode() {
        return this.mask_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IntBitsAnySet()))
          return false;
        if (!(this.mask_1 === other.mask_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IntBitsAnySet', VOID, VOID, VOID, VOID, VOID, {0: ConditionIntBitsAnySetSerializer_getInstance});
    IntBitsAnySetClass = $;
  }
  return IntBitsAnySetClass;
}
var ListAllElementsClass;
function ListAllElements() {
  if (ListAllElementsClass === VOID) {
    class $ extends Condition() {
      constructor(condition) {
        return new.target.new_com_lightningkite_services_database_Condition_ListAllElements_z68vy4_k$(condition);
      }
      static new_com_lightningkite_services_database_Condition_ListAllElements_z68vy4_k$(condition) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.condition_1 = condition;
        return $this;
      }
      invoke_n3l8sd_k$(on) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp;
          if (isInterface(on, Collection())) {
            tmp = on.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = on.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (!this.condition_1.invoke_wbynzd_k$(element)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_n3l8sd_k$((!(on == null) ? isInterface(on, KtList()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.all { it' + toString(this.condition_1) + ' }';
      }
      hashCode() {
        return this.condition_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListAllElements()))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ListAllElements', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_19});
    ListAllElementsClass = $;
  }
  return ListAllElementsClass;
}
var ListAnyElementsClass;
function ListAnyElements() {
  if (ListAnyElementsClass === VOID) {
    class $ extends Condition() {
      constructor(condition) {
        return new.target.new_com_lightningkite_services_database_Condition_ListAnyElements_6syhif_k$(condition);
      }
      static new_com_lightningkite_services_database_Condition_ListAnyElements_6syhif_k$(condition) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.condition_1 = condition;
        return $this;
      }
      invoke_n3l8sd_k$(on) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(on, Collection())) {
            tmp = on.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = on.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (this.condition_1.invoke_wbynzd_k$(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        return tmp$ret$0;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_n3l8sd_k$((!(on == null) ? isInterface(on, KtList()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.any { it' + toString(this.condition_1) + ' }';
      }
      hashCode() {
        return this.condition_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListAnyElements()))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ListAnyElements', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_20});
    ListAnyElementsClass = $;
  }
  return ListAnyElementsClass;
}
var ListSizesEqualsClass;
function ListSizesEquals() {
  if (ListSizesEqualsClass === VOID) {
    class $ extends Condition() {
      constructor(count) {
        return new.target.new_com_lightningkite_services_database_Condition_ListSizesEquals_7rtnm8_k$(count);
      }
      static new_com_lightningkite_services_database_Condition_ListSizesEquals_7rtnm8_k$(count) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.count_1 = count;
        return $this;
      }
      invoke_n3l8sd_k$(on) {
        return on.get_size_woubt6_k$() === this.count_1;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_n3l8sd_k$((!(on == null) ? isInterface(on, KtList()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.size == ' + this.count_1;
      }
      hashCode() {
        return this.count_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ListSizesEquals()))
          return false;
        if (!(this.count_1 === other.count_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ListSizesEquals', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_21});
    ListSizesEqualsClass = $;
  }
  return ListSizesEqualsClass;
}
var SetAllElementsClass;
function SetAllElements() {
  if (SetAllElementsClass === VOID) {
    class $ extends Condition() {
      constructor(condition) {
        return new.target.new_com_lightningkite_services_database_Condition_SetAllElements_tgnq18_k$(condition);
      }
      static new_com_lightningkite_services_database_Condition_SetAllElements_tgnq18_k$(condition) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.condition_1 = condition;
        return $this;
      }
      invoke_6i1cin_k$(on) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp;
          if (isInterface(on, Collection())) {
            tmp = on.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = on.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (!this.condition_1.invoke_wbynzd_k$(element)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_6i1cin_k$((!(on == null) ? isInterface(on, KtSet()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.all { it' + toString(this.condition_1) + ' }';
      }
      hashCode() {
        return this.condition_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetAllElements()))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SetAllElements', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_22});
    SetAllElementsClass = $;
  }
  return SetAllElementsClass;
}
var SetAnyElementsClass;
function SetAnyElements() {
  if (SetAnyElementsClass === VOID) {
    class $ extends Condition() {
      constructor(condition) {
        return new.target.new_com_lightningkite_services_database_Condition_SetAnyElements_13dblj_k$(condition);
      }
      static new_com_lightningkite_services_database_Condition_SetAnyElements_13dblj_k$(condition) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.condition_1 = condition;
        return $this;
      }
      invoke_6i1cin_k$(on) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.any' call
          var tmp;
          if (isInterface(on, Collection())) {
            tmp = on.isEmpty_y1axqb_k$();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = false;
            break $l$block_0;
          }
          var _iterator__ex2g4s = on.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (this.condition_1.invoke_wbynzd_k$(element)) {
              tmp$ret$0 = true;
              break $l$block_0;
            }
          }
          tmp$ret$0 = false;
        }
        return tmp$ret$0;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_6i1cin_k$((!(on == null) ? isInterface(on, KtSet()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.any { it' + toString(this.condition_1) + ' }';
      }
      hashCode() {
        return this.condition_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetAnyElements()))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SetAnyElements', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_23});
    SetAnyElementsClass = $;
  }
  return SetAnyElementsClass;
}
var SetSizesEqualsClass;
function SetSizesEquals() {
  if (SetSizesEqualsClass === VOID) {
    class $ extends Condition() {
      constructor(count) {
        return new.target.new_com_lightningkite_services_database_Condition_SetSizesEquals_nfbfuo_k$(count);
      }
      static new_com_lightningkite_services_database_Condition_SetSizesEquals_nfbfuo_k$(count) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.count_1 = count;
        return $this;
      }
      invoke_6i1cin_k$(on) {
        return on.get_size_woubt6_k$() === this.count_1;
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_6i1cin_k$((!(on == null) ? isInterface(on, KtSet()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.size == ' + this.count_1;
      }
      hashCode() {
        return this.count_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SetSizesEquals()))
          return false;
        if (!(this.count_1 === other.count_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SetSizesEquals', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_24});
    SetSizesEqualsClass = $;
  }
  return SetSizesEqualsClass;
}
var ExistsClass;
function Exists() {
  if (ExistsClass === VOID) {
    class $ extends Condition() {
      constructor(key) {
        return new.target.new_com_lightningkite_services_database_Condition_Exists_m75oda_k$(key);
      }
      static new_com_lightningkite_services_database_Condition_Exists_m75oda_k$(key) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.key_1 = key;
        return $this;
      }
      invoke_2a8pdg_k$(on) {
        return on.containsKey_aw81wo_k$(this.key_1);
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_2a8pdg_k$((!(on == null) ? isInterface(on, KtMap()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '.containsKey(' + this.key_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.key_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Exists()))
          return false;
        if (!(this.key_1 === other.key_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Exists', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_25});
    ExistsClass = $;
  }
  return ExistsClass;
}
var OnKeyClass;
function OnKey() {
  if (OnKeyClass === VOID) {
    class $ extends Condition() {
      constructor(key, condition) {
        return new.target.new_com_lightningkite_services_database_Condition_OnKey_bbz9he_k$(key, condition);
      }
      static new_com_lightningkite_services_database_Condition_OnKey_bbz9he_k$(key, condition) {
        Companion_getInstance_26();
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.key_1 = key;
        $this.condition_1 = condition;
        return $this;
      }
      invoke_2a8pdg_k$(on) {
        return on.containsKey_aw81wo_k$(this.key_1) && this.condition_1.invoke_wbynzd_k$(on.get_wei43m_k$(this.key_1));
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_2a8pdg_k$((!(on == null) ? isInterface(on, KtMap()) : false) ? on : THROW_CCE());
      }
      toString() {
        return '[' + this.key_1 + ']' + toString(this.condition_1);
      }
      hashCode() {
        var result = getStringHashCode(this.key_1);
        result = imul(result, 31) + this.condition_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OnKey()))
          return false;
        if (!(this.key_1 === other.key_1))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_Condition_OnKey_hbw11w_k$(seen0, key, condition, serializationConstructorMarker) {
        Companion_getInstance_26();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, Companion_getInstance_26().$cachedDescriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.key_1 = key;
        $this.condition_1 = condition;
        return $this;
      }
    }
    initMetadataForClass($, 'OnKey', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_26});
    OnKeyClass = $;
  }
  return OnKeyClass;
}
var OnFieldClass;
function OnField() {
  if (OnFieldClass === VOID) {
    class $ extends Condition() {
      constructor(key, condition) {
        return new.target.new_com_lightningkite_services_database_Condition_OnField_tgn7de_k$(key, condition);
      }
      static new_com_lightningkite_services_database_Condition_OnField_tgn7de_k$(key, condition) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.key_1 = key;
        $this.condition_1 = condition;
        return $this;
      }
      invoke_4z0ew0_k$(on) {
        return this.condition_1.invoke_wbynzd_k$(this.key_1.get_g4cbzo_k$(on));
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_4z0ew0_k$(on);
      }
      toString() {
        var tmp;
        var tmp_0 = this.condition_1;
        if (tmp_0 instanceof OnField()) {
          tmp = this.key_1.get_name_woqyms_k$() + '.' + toString(this.condition_1);
        } else {
          tmp = this.key_1.get_name_woqyms_k$() + toString(this.condition_1);
        }
        return tmp;
      }
      hashCode() {
        var result = hashCode(this.key_1);
        result = imul(result, 31) + this.condition_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OnField()))
          return false;
        if (!equals(this.key_1, other.key_1))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'OnField');
    OnFieldClass = $;
  }
  return OnFieldClass;
}
var IfNotNullClass;
function IfNotNull() {
  if (IfNotNullClass === VOID) {
    class $ extends Condition() {
      constructor(condition) {
        return new.target.new_com_lightningkite_services_database_Condition_IfNotNull_b1oyp_k$(condition);
      }
      static new_com_lightningkite_services_database_Condition_IfNotNull_b1oyp_k$(condition) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.condition_1 = condition;
        return $this;
      }
      invoke_jhvsfi_k$(on) {
        return !(on == null) && this.condition_1.invoke_wbynzd_k$(on);
      }
      invoke_wbynzd_k$(on) {
        return this.invoke_jhvsfi_k$(on);
      }
      toString() {
        return '? ' + toString(this.condition_1);
      }
      hashCode() {
        return this.condition_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IfNotNull()))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IfNotNull', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_27});
    IfNotNullClass = $;
  }
  return IfNotNullClass;
}
var IfIsTypeClass;
function IfIsType() {
  if (IfIsTypeClass === VOID) {
    class $ extends Condition() {
      constructor(discriminator, condition) {
        return new.target.new_com_lightningkite_services_database_Condition_IfIsType_20q63z_k$(discriminator, condition);
      }
      static new_com_lightningkite_services_database_Condition_IfIsType_20q63z_k$(discriminator, condition) {
        var $this = this.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
        $this.discriminator_1 = discriminator;
        $this.condition_1 = condition;
        return $this;
      }
      static new_com_lightningkite_services_database_Condition_IfIsType_1eitre_k$(type, condition) {
        return this.new_com_lightningkite_services_database_Condition_IfIsType_20q63z_k$(_SealedTypeDiscriminator___init__impl__jf77jn(type), condition);
      }
      invoke_wbynzd_k$(on) {
        // Inline function 'com.lightningkite.services.database.handle' call
        var this_0 = this.discriminator_1;
        var tmp;
        if (matches(this_0, on)) {
          tmp = this.condition_1.invoke_wbynzd_k$(on);
        } else {
          tmp = false;
        }
        return tmp;
      }
      toString() {
        return ' as? ' + _SealedTypeDiscriminator___get_serialName__impl__x46m55(this.discriminator_1) + ' ' + toString(this.condition_1);
      }
      hashCode() {
        var result = SealedTypeDiscriminator__hashCode_impl_3l9vn8(this.discriminator_1);
        result = imul(result, 31) + this.condition_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IfIsType()))
          return false;
        if (!(this.discriminator_1 === other.discriminator_1))
          return false;
        if (!this.condition_1.equals(other.condition_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'IfIsType');
    IfIsTypeClass = $;
  }
  return IfIsTypeClass;
}
var CompanionClass_28;
function Companion_28() {
  if (CompanionClass_28 === VOID) {
    class $ {
      serializer_qelnde_k$(typeSerial0) {
        return new (ConditionSerializer())(typeSerial0);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_qelnde_k$(typeParamsSerializers[0]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_28 = $;
  }
  return CompanionClass_28;
}
var Companion_instance_29;
function Companion_getInstance_28() {
  return Companion_instance_29;
}
var ConditionClass;
function Condition() {
  if (ConditionClass === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_services_database_Condition_8kx6q3_k$();
      }
      static new_com_lightningkite_services_database_Condition_8kx6q3_k$() {
        return createThis(this);
      }
      hashCode() {
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$();
      }
      equals(other) {
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$();
      }
      invoke_wbynzd_k$(on) {
        throw NotImplementedError().new_kotlin_NotImplementedError_8rzvsv_k$();
      }
    }
    initMetadataForClass($, 'Condition', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_28});
    ConditionClass = $;
  }
  return ConditionClass;
}
function and(_this__u8e3s4, other) {
  return And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOf([_this__u8e3s4, other]));
}
function or(_this__u8e3s4, other) {
  return Or().new_com_lightningkite_services_database_Condition_Or_k1egk7_k$(listOf([_this__u8e3s4, other]));
}
//region block: init
Companion_instance_0 = new (Companion())();
Companion_instance_1 = new (Companion_0())();
Companion_instance_2 = new (Companion_1())();
Companion_instance_3 = new (Companion_2())();
Companion_instance_4 = new (Companion_3())();
Companion_instance_5 = new (Companion_4())();
Companion_instance_6 = new (Companion_5())();
Companion_instance_7 = new (Companion_6())();
Companion_instance_8 = new (Companion_7())();
Companion_instance_9 = new (Companion_8())();
Companion_instance_10 = new (Companion_9())();
Companion_instance_11 = new (Companion_10())();
Companion_instance_13 = new (Companion_12())();
Companion_instance_15 = new (Companion_14())();
Companion_instance_16 = new (Companion_15())();
Companion_instance_17 = new (Companion_16())();
Companion_instance_18 = new (Companion_17())();
Companion_instance_19 = new (Companion_18())();
Companion_instance_20 = new (Companion_19())();
Companion_instance_21 = new (Companion_20())();
Companion_instance_22 = new (Companion_21())();
Companion_instance_23 = new (Companion_22())();
Companion_instance_24 = new (Companion_23())();
Companion_instance_25 = new (Companion_24())();
Companion_instance_26 = new (Companion_25())();
Companion_instance_28 = new (Companion_27())();
Companion_instance_29 = new (Companion_28())();
//endregion
//region block: exports
export {
  Always as Always2gnog82xa5sk4,
  And as And1a3dbpwh0hxmu,
  Equal as Equal31pr842ymh8s6,
  Exists as Exists1exqiojwnd9mi,
  FullTextSearch as FullTextSearch2zmuqp5auopao,
  GeoDistance as GeoDistance1rltmqiyjdtif,
  GreaterThanOrEqual as GreaterThanOrEqual3ghjzsakr35no,
  GreaterThan as GreaterThan3vt01ywx1j4sj,
  IfIsType as IfIsType2zdboewhql4da,
  IfNotNull as IfNotNullvieyp8szlv3m,
  Inside as Inside34e21e5w7gmr5,
  IntBitsAnyClear as IntBitsAnyClear3t38gmzr6rff9,
  IntBitsAnySet as IntBitsAnySet1h0wqrlg4jeoy,
  IntBitsClear as IntBitsClearbho942xfl833,
  IntBitsSet as IntBitsSetumkgdrh8gq7a,
  LessThanOrEqual as LessThanOrEqual3o5tj78evuy34,
  LessThan as LessThan328qpp4kkt6qa,
  ListAllElements as ListAllElements2qkljsceytb8,
  ListAnyElements as ListAnyElements3oaaxxe9tp3p5,
  ListSizesEquals as ListSizesEquals1le0b8ydqpsi0,
  Never as Neverceenm6qv9xac,
  NotEqual as NotEqual3by2u1rdr6xhj,
  NotInside as NotInside2gyw9f0e86unn,
  Not as Notasovrzfq2v0i,
  OnField as OnField2kq8b4gk936v8,
  OnKey as OnKey39cswdy1celtm,
  Or as Or37bzl6q9twftg,
  RawStringContains as RawStringContains3pup1bkmqxswn,
  RegexMatches as RegexMatchese9oiefmyt4mq,
  SetAllElements as SetAllElementso97viygbubrg,
  SetAnyElements as SetAnyElements2se8zlywewplk,
  SetSizesEquals as SetSizesEquals3hpr35evyoger,
  StringContains as StringContains1bog4sdhgv5sy,
  Condition as Conditionlbcfpsbet24r,
  and as and3dbt2f202um49,
  or as or1uh2qn0k1rz6c,
  Always_getInstance as Always_getInstance177eud73uc475,
  Companion_instance_0 as Companion_instance2q8fv6rz9kty0,
  Companion_instance_29 as Companion_instance170wh3hu8c61,
  Companion_instance_3 as Companion_instance1x5ptgth8zhxi,
  Companion_instance_26 as Companion_instancehonhf7q97gvq,
  Companion_getInstance_13 as Companion_getInstance2n1o7xahtwe38,
  Companion_instance_13 as Companion_instance334xz54gwgpk7,
  Companion_instance_7 as Companion_instanceph7m2qn20p7q,
  Companion_instance_9 as Companion_instance2z7r598ruzfgp,
  Companion_instance_28 as Companion_instance326hk1r71xax,
  Companion_instance_5 as Companion_instance27qzp1hsrgk5v,
  Companion_instance_18 as Companion_instance2sjog5kofh6gw,
  Companion_instance_19 as Companion_instance2j477vxcf0eam,
  Companion_instance_16 as Companion_instancefyqtx24roelu,
  Companion_instance_17 as Companion_instance15i08a3149tp6,
  Companion_instance_8 as Companion_instancetlzvdhi57ju2,
  Companion_instance_10 as Companion_instanceh57sw6cyw523,
  Companion_instance_20 as Companion_instance1rv4h7xeh426o,
  Companion_instance_21 as Companion_instance9b6acjoxpq0c,
  Companion_instance_22 as Companion_instance3s54ycq8t72xu,
  Never_getInstance as Never_getInstance3of1faxayn0qw,
  Companion_instance_2 as Companion_instance1rxmb5wyn6fsk,
  Companion_instance_4 as Companion_instance3sjn2yjp2itr2,
  Companion_instance_6 as Companion_instance2ofs92i7mv51v,
  Companion_getInstance_26 as Companion_getInstance1r7wm1v3dq4i3,
  Companion_instance_1 as Companion_instancen43ljy30xhzi,
  Companion_getInstance_11 as Companion_getInstance2w0ry8ukons4w,
  Companion_instance_15 as Companion_instance28iz6ufuyency,
  Companion_instance_23 as Companion_instance1xqhrale4ydxi,
  Companion_instance_24 as Companion_instance2igigxyt265zn,
  Companion_instance_25 as Companion_instanceheuor90dqw2p,
  Companion_instance_11 as Companion_instance2auwgabo579v8,
};
//endregion

//# sourceMappingURL=Condition.mjs.map
